module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAQAAAD8fJRsAAAAEklEQVR4AWMYeGCACnFLDDQAAMG7AwFP5h97AAAAAElFTkSuQmCC"